import { IObjektVy } from '../../../../../Types/ObjektVy';
import { collectionCompToObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';
import { BudgetAskandemallar } from './BudgetAskandemallar';

const BudgetAskandemallarObjektVy = collectionCompToObjektVy(
  BudgetAskandemallar,
  'BudgetAskandemallar'
);

export const BudgetAskandemallarVyer: IObjektVy[] = [
  BudgetAskandemallarObjektVy,
];
